export default __webpack_public_path__ + "static/logo_dna-a2f787fc85ab921445cf0fdf150feaad.png";